module.exports = "/location-0f9ee7d5ed4f2c2a61cb7bb50d8b60d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/MapComponents/LocationMarker/icons/location.svg
// module id = N7A0
// module chunks = 4